<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <p>
                    Pedidos emitidos
                    <span v-if="de">de <span class="text-primary">{{ de }}</span></span>
                    <span v-if="ate">até <span class="text-primary">{{ ate }}</span></span>
                </p>
            </div>
        </div>

        <div v-if="lastError" class="alert alert-danger">
            {{ lastError }}
        </div>

        <!-- Filtros (acima), seguindo o layout antigo -->
        <div class="row mb-3">
            <div class="col-12 col-md-6 mb-3">
                <label class="form-label">&nbsp;</label>
                <div class="input-group">
                    <span class="input-group-text"><i class="fas fa-search"></i></span>
                    <input v-model="q" type="text" class="form-control" placeholder="Pesquisar cliente..."
                        autocomplete="off" @input="onSearchInput" />
                </div>
            </div>
            <div class="col-12 col-md-2 mb-3">
                <label class="form-label w-100 text-center">Data Inicial</label>
                <input ref="deInput" type="text" class="form-control text-center datetimepicker" v-model="de"
                    autocomplete="off" />
            </div>
            <div class="col-12 col-md-2 mb-3">
                <label class="form-label w-100 text-center">Data Final</label>
                <input ref="ateInput" type="text" class="form-control text-center datetimepicker" v-model="ate"
                    autocomplete="off" />
            </div>
            <div class="col-12 col-md-2 mb-3">
                <label class="form-label">&nbsp;</label>
                <div class="btn-group w-100" role="group">
                    <button type="button" class="btn btn-primary" @click="fetchClientes({ reset: true })"
                        :disabled="clientesLoading">
                        <i class="fas fa-search"></i> Pesquisar
                    </button>
                    <button type="button" class="btn btn-danger" @click="resetFilters" :disabled="clientesLoading">
                        <i class="fas fa-eraser"></i> Reset
                    </button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="accordion" id="empresas">
                    <div v-for="c in clientes" :key="c.id" class="card rounded-0" :id="`card-${c.id}`">
                        <div v-if="successMessageByCliente[c.id]" class="card-body">
                            <div class="alert alert-success mb-0 d-flex align-items-center justify-content-between">
                                <div>
                                    <strong>{{ successMessageByCliente[c.id] }}</strong>
                                    <span v-if="successSecondsByCliente[c.id] > 0" class="ms-2 text-muted">
                                        {{ successSecondsByCliente[c.id] }}s
                                    </span>
                                </div>
                                <button type="button" class="btn btn-sm btn-outline-success"
                                    @click="dismissClienteSuccess(c.id, true)">OK</button>
                            </div>
                        </div>

                        <template v-else>
                            <div class="card-header border-0" :id="`heading-${c.id}`">
                                <button class="btn btn-link w-100 text-start text-decoration-none text-primary"
                                    type="button" data-bs-toggle="collapse" :data-bs-target="`#collapse-${c.id}`"
                                    aria-expanded="false" :aria-controls="`collapse-${c.id}`"
                                    @click="ensurePedidosLoaded(c)">
                                    <div class="row d-flex align-items-center">
                                        <div class="col-md-9">
                                            <span class="float-left mt-2">{{ c.name }}</span>
                                            <a :href="empresaEditLink(c.id)" target="_blank"
                                                class="btn btn-link btn-light">
                                                <i class="fas fa-edit"></i>
                                            </a>
                                        </div>
                                        <div class="col text-center">
                                            <i v-if="c.tag_wallet" class="fas fa-wallet p-1" style="color:brown;"
                                                title="Carteira"></i>
                                            <i v-if="(c.fat_emails_count || 0) > 0" class="fas fa-at text-success p-1"
                                                title="Envio por E-mail"></i>
                                            <i v-else class="fas fa-envelope text-warning p-1"
                                                title="Envio por Correio"></i>
                                        </div>
                                        <div class="col">
                                            <span class="w-100 badge bg-primary ms-3">
                                                {{ (c.pedidos_pendentes_count || 0) }} {{ (c.pedidos_pendentes_count ||
                                                    0) > 1 ? 'pedidos' : 'pedido' }}
                                            </span>
                                        </div>
                                    </div>
                                </button>
                            </div>
                            <div class="collapse border-0" :id="`collapse-${c.id}`" :aria-labelledby="`heading-${c.id}`"
                                data-parent="#empresas">
                                <div class="card-body border-0">
                                    <div class="table-responsive">
                                        <table class="table align-middle mb-0">
                                            <thead class="table-secondary">
                                                <tr>
                                                    <th class="text-center" style="width: 75px;">
                                                        <div class="form-check">
                                                            <input type="checkbox" class="form-check-input"
                                                                :id="`checkAll-${c.id}`"
                                                                @change="toggleAll(c.id, $event.target.checked)" />
                                                            <label class="form-check-label"
                                                                :for="`checkAll-${c.id}`"></label>
                                                        </div>
                                                    </th>
                                                    <th class="text-center" style="width: 15%;">Nº Pedido</th>
                                                    <th class="text-center" style="width: 15%;">Emissao</th>
                                                    <th class="text-end" style="width: 15%;">Valor</th>
                                                    <th class="text-start">Observacao para NF-e</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="p in pedidosByCliente[c.id] || []" :key="p.id">
                                                    <td class="text-center">
                                                        <div class="form-check">
                                                            <input type="checkbox" class="form-check-input"
                                                                :id="`pedido-${p.id}`"
                                                                :checked="(faturamentoByCliente[c.id] && faturamentoByCliente[c.id].selected[p.id]) || false"
                                                                @change="togglePedido(c.id, p.id, $event.target.checked)" />
                                                            <label class="form-check-label"
                                                                :for="`pedido-${p.id}`"></label>
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        <a :href="pedidoLink(p.id)" target="_blank"
                                                            class="btn text-primary">
                                                            {{ p.id }} <i class="fas fa-external-link-alt"></i>
                                                        </a>
                                                    </td>
                                                    <td class="text-center">{{ fmtDate(p.created_at) }}</td>
                                                    <td class="text-end">{{ fmtMoney(p.valor_total) }}</td>
                                                    <td class="text-start">
                                                        <input type="text" class="form-control"
                                                            :value="(faturamentoByCliente[c.id] && faturamentoByCliente[c.id].obs[p.id]) || ''"
                                                            @change="
                                                                (faturamentoByCliente[c.id] && $set(faturamentoByCliente[c.id].obs, p.id, $event.target.value)) ||
                                                                null;
                                                            recalcFatura(c.id);
                                                            " />
                                                    </td>
                                                </tr>

                                                <tr v-if="pedidosLoadingByCliente[c.id]">
                                                    <td colspan="5" class="text-center text-muted py-3">
                                                        <div class="spinner-border text-primary" role="status"
                                                            aria-hidden="true"></div>
                                                        <span class="visually-hidden">Carregando...</span>
                                                    </td>
                                                </tr>
                                                <tr v-else-if="(pedidosByCliente[c.id] || []).length === 0">
                                                    <td colspan="5" class="text-center text-muted py-3">Nenhum pedido
                                                        encontrado.</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <!-- Form de faturamento (essencial) -->
                                    <div v-if="faturamentoByCliente[c.id]" class="mt-3">
                                        <div class="row">
                                            <div class="col-md mb-3">
                                                <label class="form-label">Desconto em Nota</label>
                                                <div class="input-group">
                                                    <input type="number" step="0.01" class="form-control text-center"
                                                        v-model="faturamentoByCliente[c.id].pDesc"
                                                        @change="recalcFatura(c.id)" />
                                                    <span class="input-group-text">%</span>
                                                </div>
                                            </div>
                                            <div class="col-md mb-3">
                                                <label class="form-label">Parcelamento</label>
                                                <select class="form-control"
                                                    v-model="faturamentoByCliente[c.id].forma_id"
                                                    @change="recalcFatura(c.id)">
                                                    <option value="" selected>Escolha</option>
                                                    <option v-for="f in formas" :key="f.id" :value="String(f.id)">{{
                                                        f.name }}</option>
                                                </select>
                                            </div>
                                            <div class="col-md mb-3">
                                                <label class="form-label">Especie</label>
                                                <select class="form-control"
                                                    v-model="faturamentoByCliente[c.id].especie_id"
                                                    @change="recalcFatura(c.id)">
                                                    <option value="" selected>Escolha</option>
                                                    <option v-for="e in especies" :key="e.id" :value="String(e.id)">{{
                                                        e.name }}</option>
                                                </select>
                                            </div>
                                            <div class="col-md mb-3">
                                                <label class="form-label">Data Base</label>
                                                <input type="date" class="form-control text-center"
                                                    v-model="faturamentoByCliente[c.id].data_base"
                                                    @change="recalcFatura(c.id)" />
                                            </div>
                                        </div>

                                        <div class="row mb-2">
                                            <div class="col">
                                                <span class="badge bg-success fs-6">
                                                    <span class="text-xs">Total:</span> {{
                                                        fmtMoney(faturamentoByCliente[c.id].valor_total) }}
                                                </span>
                                                <span class="badge bg-danger fs-6 ms-2">
                                                    <span class="text-xs">Desconto:</span> {{
                                                        fmtMoney(faturamentoByCliente[c.id].valor_desconto) }}
                                                </span>
                                            </div>
                                        </div>

                                        <div v-if="faturamentoByCliente[c.id].duplicatasLoading" class="text-muted">
                                            Calculando duplicatas...
                                        </div>

                                        <div v-else-if="(faturamentoByCliente[c.id].duplicatas || []).length"
                                            class="table-responsive">
                                            <table class="planilha p-0 table table-bordered">
                                                <thead class="table-light">
                                                    <tr>
                                                        <th class="text-center" style="width:100px;">Parcela</th>
                                                        <th class="text-center">Emissao</th>
                                                        <th class="text-center">Vencimento</th>
                                                        <th class="text-end">Valor</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(d, idx) in faturamentoByCliente[c.id].duplicatas"
                                                        :key="idx">
                                                        <td>
                                                            <input class="form-control text-center"
                                                                v-model="d.parcela" />
                                                        </td>
                                                        <td>
                                                            <input type="date" class="form-control text-center"
                                                                v-model="d.emissao" />
                                                        </td>
                                                        <td>
                                                            <input type="date" class="form-control text-center"
                                                                v-model="d.vencimento" />
                                                        </td>
                                                        <td>
                                                            <input class="form-control text-end" type="number"
                                                                step="0.01" v-model="d.valor" />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div class="row">
                                            <div class="col text-end">
                                                <button type="button" class="btn btn-success"
                                                    :disabled="faturamentoByCliente[c.id].faturando"
                                                    @click="faturar(c.id)">
                                                    <i class="fas fa-angle-double-right"></i>
                                                    {{ faturamentoByCliente[c.id].faturando ? 'Faturando...' : 'Faturar'
                                                    }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>

                    <div v-if="clientesLoading" class="p-3 text-center text-muted">
                        <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
                        <span class="visually-hidden">Carregando...</span>
                    </div>
                    <div v-else-if="clientes.length === 0" class="p-3 text-center text-muted">
                        Nenhum cliente encontrado.
                    </div>
                    <div v-else-if="!clientesNextUrl" class="p-3 text-center text-muted">
                        Fim da lista.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import debounce from 'lodash/debounce';

export default {
    name: 'FaturamentoPedidos2',
    props: {
        formas: { type: Array, default: () => [] },
        especies: { type: Array, default: () => [] },
    },
    data() {
        return {
            q: '',
            clientes: [],
            clientesNextUrl: null,
            clientesLoading: false,
            de: '',
            ate: '',

            pedidosByCliente: {},
            pedidosLoadingByCliente: {},
            faturamentoByCliente: {},

            lastError: null,
            successMessageByCliente: {},
            successSecondsByCliente: {},
            successTimeoutIdByCliente: {},
            successIntervalIdByCliente: {},

            // Vue 2 nao faz proxy de chaves que comecam com "_" ou "$"
            clientesReqSeq: 0,
            pedidosReqSeqByCliente: {},
            debouncedSearch: null,
        };
    },
    created() {
        console.log('[Pedidos2] created');
        // Mantem o comportamento antigo: ate default = hoje + 1 dia (mostra "ate" como amanha)
        const today = new Date();
        const tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        this.ate = this.formatDMY(tomorrow);
        console.log('[Pedidos2] initial filters', { q: this.q, de: this.de, ate: this.ate });
        this.fetchClientes({ reset: true });
    },
    mounted() {
        console.log('[Pedidos2] mounted');
        this.initDatepickers();
        window.addEventListener('scroll', this.onWindowScroll, { passive: true });
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onWindowScroll);
        // Limpa timers de sucesso por cliente
        Object.keys(this.successTimeoutIdByCliente || {}).forEach((k) => this.dismissClienteSuccess(Number(k), false));
    },
    methods: {
        showClienteSuccess(clienteId, message) {
            this.dismissClienteSuccess(clienteId, false);
            this.$set(this.successMessageByCliente, clienteId, message || 'Sucesso.');
            this.$set(this.successSecondsByCliente, clienteId, 5);

            const intervalId = setInterval(() => {
                const cur = Number(this.successSecondsByCliente[clienteId] || 0);
                if (cur > 0) this.$set(this.successSecondsByCliente, clienteId, cur - 1);
            }, 1000);
            const timeoutId = setTimeout(() => {
                this.dismissClienteSuccess(clienteId, true);
            }, 5000);

            this.$set(this.successIntervalIdByCliente, clienteId, intervalId);
            this.$set(this.successTimeoutIdByCliente, clienteId, timeoutId);
        },
        dismissClienteSuccess(clienteId, removeCard) {
            const t = this.successTimeoutIdByCliente[clienteId];
            if (t) {
                clearTimeout(t);
                this.$delete(this.successTimeoutIdByCliente, clienteId);
            }
            const i = this.successIntervalIdByCliente[clienteId];
            if (i) {
                clearInterval(i);
                this.$delete(this.successIntervalIdByCliente, clienteId);
            }
            if (this.successMessageByCliente[clienteId]) this.$delete(this.successMessageByCliente, clienteId);
            if (this.successSecondsByCliente[clienteId] !== undefined) this.$delete(this.successSecondsByCliente, clienteId);

            if (removeCard) {
                this.clientes = (this.clientes || []).filter((c) => c.id !== clienteId);
                // Libera memoria/cache
                if (this.pedidosByCliente[clienteId]) this.$delete(this.pedidosByCliente, clienteId);
                if (this.pedidosLoadingByCliente[clienteId] !== undefined) this.$delete(this.pedidosLoadingByCliente, clienteId);
                if (this.faturamentoByCliente[clienteId]) this.$delete(this.faturamentoByCliente, clienteId);
            }
        },
        initDatepickers() {
            if (!window.$ || !$.datetimepicker) {
                console.warn('[Pedidos2] datetimepicker not available', { $: typeof window.$, dtp: typeof ($ && $.datetimepicker) });
                return;
            }
            $.datetimepicker.setLocale('pt');

            const setup = (el, onChange) => {
                $(el).datetimepicker({
                    format: 'd/m/Y',
                    timepicker: false,
                    onChangeDateTime: function (dp, $input) {
                        onChange($input.val());
                    },
                });
            };

            if (this.$refs.deInput) {
                setup(this.$refs.deInput, (v) => (this.de = v));
            }
            if (this.$refs.ateInput) {
                setup(this.$refs.ateInput, (v) => (this.ate = v));
            }
            console.log('[Pedidos2] datetimepicker initialized');
        },
        resetFilters() {
            console.log('[Pedidos2] resetFilters');
            this.q = '';
            this.de = '';
            const today = new Date();
            const tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
            this.ate = this.formatDMY(tomorrow);

            this.pedidosByCliente = {};
            this.pedidosLoadingByCliente = {};
            this.faturamentoByCliente = {};
            this.fetchClientes({ reset: true });
        },
        onSearchInput() {
            console.log('[Pedidos2] onSearchInput', { q: this.q });
            if (!this.debouncedSearch) {
                this.debouncedSearch = debounce(() => {
                    console.log('[Pedidos2] debounced search firing', { q: this.q, de: this.de, ate: this.ate });
                    this.pedidosByCliente = {};
                    this.pedidosLoadingByCliente = {};
                    this.faturamentoByCliente = {};
                    this.fetchClientes({ reset: true });
                }, 350);
            }
            this.debouncedSearch();
        },
        fetchClientes({ url = null, reset = false } = {}) {
            try {
                this.lastError = null;
                if (this.clientesLoading) {
                    console.log('[Pedidos2] fetchClientes skipped (already loading)');
                    return;
                }
                if (reset) {
                    this.clientes = [];
                    this.clientesNextUrl = null;
                }

                const seq = ++this.clientesReqSeq;
                this.clientesLoading = true;

                const baseUrl = '/faturamento/pedidos2/clientes';
                const reqUrl =
                    url ||
                    `${baseUrl}?q=${encodeURIComponent(this.q || '')}&de=${encodeURIComponent(this.de || '')}&ate=${encodeURIComponent(
                        this.ate || ''
                    )}&per_page=25`;

                console.log('[Pedidos2] fetchClientes start', { seq, reqUrl, reset });
                axios
                    .get(reqUrl)
                    .then((res) => {
                        if (seq !== this.clientesReqSeq) {
                            console.log('[Pedidos2] fetchClientes stale response ignored', { seq, current: this.clientesReqSeq });
                            return;
                        }
                        const payload = res.data || {};
                        const data = payload.data || [];
                        console.log('[Pedidos2] fetchClientes response', {
                            seq,
                            status: res.status,
                            count: Array.isArray(data) ? data.length : null,
                            hasNext: !!payload.next_page_url,
                        });
                        this.clientes = reset ? data : this.clientes.concat(data);
                        this.clientesNextUrl = payload.next_page_url || null;
                    })
                    .catch((err) => {
                        console.error('[Pedidos2] fetchClientes error', err);
                        const status = err && err.response ? err.response.status : null;
                        this.lastError = status ? `Erro ao carregar clientes (HTTP ${status}).` : 'Erro ao carregar clientes.';
                    })
                    .finally(() => {
                        if (seq === this.clientesReqSeq) {
                            this.clientesLoading = false;
                            console.log('[Pedidos2] fetchClientes finally', { seq, clientesLoading: this.clientesLoading, clientes: this.clientes.length });
                        }
                    });
            } catch (e) {
                console.error('[Pedidos2] fetchClientes fatal (sync)', e);
                this.lastError = 'Erro ao iniciar carregamento de clientes (JS).';
                this.clientesLoading = false;
            }
        },
        ensurePedidosLoaded(c) {
            const id = c.id;
            console.log('[Pedidos2] ensurePedidosLoaded', { id });
            if (this.pedidosLoadingByCliente[id]) {
                return;
            }
            if (this.pedidosByCliente[id] && this.pedidosByCliente[id].length > 0) {
                return;
            }
            this.fetchPedidos({ clienteId: id, reset: true });
        },
        fetchPedidos({ clienteId, url = null, reset = false } = {}) {
            if (!clienteId) {
                return;
            }
            if (this.pedidosLoadingByCliente[clienteId]) {
                return;
            }

            if (reset || !this.pedidosByCliente[clienteId]) {
                this.$set(this.pedidosByCliente, clienteId, []);
            }

            const nextSeq = (this.pedidosReqSeqByCliente[clienteId] || 0) + 1;
            this.$set(this.pedidosReqSeqByCliente, clienteId, nextSeq);
            const seq = nextSeq;
            this.$set(this.pedidosLoadingByCliente, clienteId, true);

            const baseUrl = `/faturamento/pedidos2/clientes/${clienteId}/pedidos`;
            const reqUrl = url || `${baseUrl}?de=${encodeURIComponent(this.de || '')}&ate=${encodeURIComponent(this.ate || '')}`;

            console.log('[Pedidos2] fetchPedidos start', { clienteId, seq, reqUrl, reset });
            axios
                .get(reqUrl)
                .then((res) => {
                    if (seq !== (this.pedidosReqSeqByCliente[clienteId] || 0)) {
                        return;
                    }
                    const payload = res.data || {};
                    const data = payload.data || [];
                    console.log('[Pedidos2] fetchPedidos response', {
                        clienteId,
                        seq,
                        status: res.status,
                        count: Array.isArray(data) ? data.length : null,
                    });
                    const cur = this.pedidosByCliente[clienteId] || [];
                    this.$set(this.pedidosByCliente, clienteId, reset ? data : cur.concat(data));

                    if (!this.faturamentoByCliente[clienteId]) {
                        const today = new Date();
                        const defaultEspecieId = this.getDefaultBoletoEspecieId();
                        this.$set(this.faturamentoByCliente, clienteId, {
                            selected: {},
                            obs: {},
                            obsNFe: '',
                            pDesc: '0.00',
                            forma_id: '',
                            especie_id: defaultEspecieId ? String(defaultEspecieId) : '',
                            // input type="date" usa YYYY-MM-DD
                            data_base: this.formatISODate(today),
                            valor_base: 0,
                            valor_total: 0,
                            valor_desconto: 0,
                            duplicatas: [],
                            is_boleto: false,
                            duplicatasLoading: false,
                            faturando: false,
                        });
                    }

                    const st = this.faturamentoByCliente[clienteId];
                    (data || []).forEach((p) => {
                        if (st.obs[p.id] === undefined) {
                            this.$set(st.obs, p.id, p.observacao || '');
                        }
                    });
                })
                .catch((err) => {
                    console.error('[Pedidos2] fetchPedidos error', err);
                    const status = err && err.response ? err.response.status : null;
                    this.lastError = status ? `Erro ao carregar pedidos (HTTP ${status}).` : 'Erro ao carregar pedidos.';
                })
                .finally(() => {
                    if (seq === (this.pedidosReqSeqByCliente[clienteId] || 0)) {
                        this.$set(this.pedidosLoadingByCliente, clienteId, false);
                        console.log('[Pedidos2] fetchPedidos finally', {
                            clienteId,
                            seq,
                            loading: this.pedidosLoadingByCliente[clienteId],
                            pedidos: (this.pedidosByCliente[clienteId] || []).length,
                        });
                    }
                });
        },
        onWindowScroll() {
            if (this.clientesLoading || !this.clientesNextUrl) {
                return;
            }
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
            const viewport = window.innerHeight || document.documentElement.clientHeight || 0;
            const height = document.documentElement.scrollHeight || 0;
            const nearBottom = scrollTop + viewport >= height - 300;
            if (nearBottom) {
                console.log('[Pedidos2] onWindowScroll nearBottom -> fetchClientes next', { next: this.clientesNextUrl });
                this.fetchClientes({ url: this.clientesNextUrl, reset: false });
            }
        },
        toggleAll(clienteId, checked) {
            const pedidos = this.pedidosByCliente[clienteId] || [];
            const st = this.faturamentoByCliente[clienteId];
            if (!st) return;
            pedidos.forEach((p) => this.$set(st.selected, p.id, !!checked));
            this.recalcFatura(clienteId);
        },
        togglePedido(clienteId, pedidoId, checked) {
            const st = this.faturamentoByCliente[clienteId];
            if (!st) return;
            this.$set(st.selected, pedidoId, !!checked);
            this.recalcFatura(clienteId);
        },
        recalcFatura(clienteId) {
            const pedidos = this.pedidosByCliente[clienteId] || [];
            const st = this.faturamentoByCliente[clienteId];
            if (!st) return;

            let vBase = 0;
            let vTotal = 0;
            const selectedIds = [];

            pedidos.forEach((p) => {
                if (st.selected[p.id]) {
                    selectedIds.push(p.id);
                    const vb = Number(p.valor_base);
                    const vt = Number(p.valor_total);
                    if (!isNaN(vb)) vBase += vb;
                    if (!isNaN(vt)) vTotal += vt;
                }
            });

            st.valor_base = vBase;
            st.valor_total = vTotal;

            let obsNFe = '';
            selectedIds.forEach((id) => {
                const obs = (st.obs[id] || '').trim();
                if (obs) obsNFe += `Pedido ${id}: ${obs}\n`;
            });
            st.obsNFe = obsNFe;

            if (st.forma_id && st.especie_id && st.data_base && st.valor_total > 0) {
                this.calculeDuplicatas(clienteId);
            } else {
                st.duplicatas = [];
                st.valor_desconto = 0;
                st.is_boleto = false;
            }
        },
        calculeDuplicatas(clienteId) {
            const st = this.faturamentoByCliente[clienteId];
            if (!st) return;
            if (!st.forma_id || !st.especie_id || !st.data_base) return;

            st.duplicatasLoading = true;
            const dataBaseDMY = this.isoToDMY(st.data_base);
            const reqUrl =
                `/faturamento/pedidos2/calcule-duplicatas?` +
                `forma_id=${encodeURIComponent(st.forma_id)}` +
                `&especie_id=${encodeURIComponent(st.especie_id)}` +
                `&empresa_id=${encodeURIComponent(clienteId)}` +
                `&data_base=${encodeURIComponent(dataBaseDMY)}` +
                `&valor_total=${encodeURIComponent(st.valor_total)}` +
                `&pDesc=${encodeURIComponent(st.pDesc || 0)}`;

            console.log('[Pedidos2] calculeDuplicatas start', { clienteId, reqUrl });
            axios
                .get(reqUrl)
                .then((res) => {
                    const payload = res.data || {};
                    st.duplicatas = (payload.duplicatas || []).map((d) => ({
                        ...d,
                        emissao: this.dmyToISO(d.emissao),
                        vencimento: this.dmyToISO(d.vencimento),
                    }));
                    st.valor_desconto = Number(payload.valor_desconto || 0);
                    st.is_boleto = !!payload.is_boleto;
                    console.log('[Pedidos2] calculeDuplicatas response', { clienteId, count: st.duplicatas.length, is_boleto: st.is_boleto });
                })
                .catch((err) => {
                    console.error('[Pedidos2] calculeDuplicatas error', err);
                    const status = err && err.response ? err.response.status : null;
                    this.lastError = status ? `Erro ao calcular duplicatas (HTTP ${status}).` : 'Erro ao calcular duplicatas.';
                })
                .finally(() => {
                    st.duplicatasLoading = false;
                });
        },
        faturar(clienteId) {
            const st = this.faturamentoByCliente[clienteId];
            if (!st) return;

            const pedidos = this.pedidosByCliente[clienteId] || [];
            const pedidoIds = pedidos.filter((p) => st.selected[p.id]).map((p) => p.id);

            if (pedidoIds.length === 0) {
                this.lastError = 'Selecione um ou mais pedidos para faturar.';
                return;
            }
            if (!st.forma_id || !st.especie_id || !st.data_base) {
                this.lastError = 'Informe Parcelamento, Especie e Data Base.';
                return;
            }

            st.faturando = true;
            const dataBaseDMY = this.isoToDMY(st.data_base);
            const duplicatasDMY = (st.duplicatas || []).map((d) => ({
                ...d,
                emissao: this.isoToDMY(d.emissao),
                vencimento: this.isoToDMY(d.vencimento),
            }));
            const payload = {
                empresa_id: clienteId,
                forma_id: st.forma_id,
                data_base: dataBaseDMY,
                especie_id: st.especie_id,
                observacao: st.obsNFe || '',
                pDesc: st.pDesc || 0,
                pedidoIds: JSON.stringify(pedidoIds),
                valor_base: st.valor_base,
                valor_desconto: st.valor_desconto || 0,
                valor_total: st.valor_total,
                duplicatas: JSON.stringify(duplicatasDMY),
            };

            console.log('[Pedidos2] faturar start', { clienteId, payload });
            axios
                .get('/ajax/faturamento/faturar', { params: payload })
                .then((res) => {
                    const data = res.data || {};
                    console.log('[Pedidos2] faturar response', data);
                    if (data.class === 'success') {
                        this.lastError = null;
                        this.showClienteSuccess(clienteId, data.message || 'Pedidos faturados com sucesso.');
                    } else {
                        this.lastError = data.message || 'Falha ao faturar.';
                    }
                })
                .catch((err) => {
                    console.error('[Pedidos2] faturar error', err);
                    const status = err && err.response ? err.response.status : null;
                    this.lastError = status ? `Erro ao faturar (HTTP ${status}).` : 'Erro ao faturar.';
                })
                .finally(() => {
                    st.faturando = false;
                });
        },
        pedidoLink(id) {
            return `/vendas/pedidos/show/${id}`;
        },
        empresaEditLink(id) {
            return `/cadastro/empresas/edit/${id}`;
        },
        formatDMY(d) {
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yy = d.getFullYear();
            return `${dd}/${mm}/${yy}`;
        },
        formatISODate(d) {
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yy = d.getFullYear();
            return `${yy}-${mm}-${dd}`;
        },
        isoToDMY(iso) {
            if (!iso || typeof iso !== 'string') return '';
            const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
            if (!m) return iso;
            return `${m[3]}/${m[2]}/${m[1]}`;
        },
        dmyToISO(dmy) {
            if (!dmy || typeof dmy !== 'string') return '';
            const iso = dmy.match(/^(\d{4})-(\d{2})-(\d{2})$/);
            if (iso) return dmy;
            const m = dmy.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
            if (!m) return dmy;
            const dd = String(m[1]).padStart(2, '0');
            const mm = String(m[2]).padStart(2, '0');
            const yy = m[3];
            return `${yy}-${mm}-${dd}`;
        },
        getDefaultBoletoEspecieId() {
            const row = (this.especies || []).find((e) => !!(e && (e.isBoleto === 1 || e.isBoleto === true)));
            return row ? row.id : null;
        },
        fmtDate(v) {
            if (!v) return '';
            const d = new Date(v);
            if (isNaN(d.getTime())) return String(v);
            return d.toLocaleDateString('pt-BR');
        },
        fmtMoney(v) {
            const n = Number(v);
            if (isNaN(n)) return String(v || '');
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n);
        },
    },
};
</script>
